export const bscPools = [
  {
    id: 'baby Wolf Coin',
    logo: 'single-assets/BIFI.png',
    name: 'babywolfcoin',
    token: 'bwolfs',
    tokenDescription: 'babywolfcoin',
    tokenAddress: '0xCa3F508B8e4Dd382eE878A314789373D80A5190A',
    tokenDecimals: 18,
    earnedToken: 'mooBIFI',
    earnedTokenAddress: '0xf7069e41C57EcC5F122093811d8c75bdB5f7c14e',
    earnContractAddress: '0xf7069e41C57EcC5F122093811d8c75bdB5f7c14e',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'baby Wolf Coin',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'baby Wolf Coin',
    assets: ['BIFI'],
    callFee: 0.5,
    withdrawalFee: '0.05%',
    buyTokenUrl: 'https://wolfswapbsc.vercel.app/#/swap?outputCurrency=0x658039559dc9D82703FBEB9FCBD76e238B229a70',
  },
  {
    id: 'banana-banana',
    logo: 'degens/BANANA.svg',
    name: 'BANANA',
    token: 'BANANA',
    tokenDescription: 'ApeSwap',
    tokenAddress: '0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95',
    tokenDecimals: 18,
    tokenDescriptionUrl: '#',
    earnedToken: 'mooApeBANANA',
    earnedTokenAddress: '0xD307e7CC6a302046b7D91D83aa4B8324cFB7a786',
    earnContractAddress: '0xD307e7CC6a302046b7D91D83aa4B8324cFB7a786',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'BANANA',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'ApeSwap',
    assets: ['BANANA'],
    callFee: 0.5,
    buyTokenUrl:
      'https://dex.apeswap.finance/#/swap?inputCurrency=0x603c7f932ED1fc6575303D8Fb018fDCBb0f39a95&outputCurrency=0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
  },
  {
    id: 'cake-cakev2',
    logo: 'single-assets/CAKE.svg',
    name: 'CAKE',
    token: 'CAKE',
    tokenDescription: 'PancakeSwap',
    tokenAddress: '0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
    tokenDecimals: 18,
    earnedToken: 'mooCakeV2',
    earnedTokenAddress: '0x97e5d50Fe0632A95b9cf1853E744E02f7D816677',
    earnContractAddress: '0x97e5d50Fe0632A95b9cf1853E744E02f7D816677',
    pricePerFullShare: 1,
    tvl: 0,
    oracle: 'tokens',
    oracleId: 'Cake',
    oraclePrice: 0,
    depositsPaused: false,
    status: 'active',
    platform: 'PancakeSwap',
    assets: ['CAKE'],
    callFee: 0.5,
    withdrawalFee: '0%',
    buyTokenUrl:
      'https://exchange.pancakeswap.finance/#/swap?outputCurrency=0x0E09FaBB73Bd3Ade0a17ECC321fD13a19e81cE82',
  },
];
